import React from 'react';
import { useNavigate } from 'react-router-dom';
import beerIcon from "../assets/page_logo.png";

function TermsOfUsePage() {
  const navigate = useNavigate();

  const OrangeBullet = ({ title, children }) => (
    <article style={{ marginBottom: "20px" }}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          color: "#ff8c00",
          marginTop: "20px",
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: "1rem",
          lineHeight: "1.8",
          marginBottom: "10px",
          color: "#444",
        }}
      >
        {children}
      </p>
    </article>
  );

  const Divider = () => (
    <hr
      style={{
        border: "none",
        borderTop: "1px solid #DE810E",
        margin: "30px 0",
      }}
    />
  );

  return (
    <div style={{ backgroundColor: "#fff" }}>
      {/* AppBar */}
      <header
        style={{
          padding: "20px 20px",
          backgroundColor: "#F9F4EA",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0 auto",
          }}
        >
          <div
            onClick={() => navigate("/")}
            style={{
              paddingTop: "5px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer", // add this so users know it's clickable
            }}
          >
            <img src={beerIcon} alt="beer icon" style={{ width: "150px" }} />
          </div>

          <button
            onClick={() => navigate("/contact")}
            style={{
              ...topHeaderButtonStyle,
              backgroundColor: "#DE810E",
              color: "white",
              marginTop: "0px",
            }}
          >
            Contact Us
          </button>
        </div>
      </header>

      {/* Title Section */}
      <section
        style={{ backgroundColor: "#F9F4EA", padding: "0px 20px 130px" }}
      >
        <h1
          style={{
            color: "#000",
            textAlign: "center",
            margin: "0px",
            fontSize: "2rem",
          }}
        >
          Terms of Service
        </h1>
      </section>

      {/* Content */}
      <main
        style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}
      >
        <p style={{ fontSize: "1rem", color: "#555" }}>
          <strong>Effective Date:</strong> August 7, 2025
        </p>
        <p style={{ fontSize: "1rem", color: "#555", marginBottom: "20px" }}>
          <strong>Last Updated:</strong> July 8, 2026
        </p>

        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#444",
            marginBottom: "30px",
          }}
        >
          Welcome to my HOOM. These Terms of Service ("Terms") govern your
          access to and use of our mobile application and related services (the
          "Service"). By accessing or using the Service, you agree to be bound
          by these Terms.
        </p>

        {/* Sections */}
        <OrangeBullet title="1. Eligibility">
          You must be at least 21 years old and legally allowed to purchase
          alcohol in your jurisdiction to use this app. By using the Service,
          you represent and warrant that you meet these requirements.
        </OrangeBullet>

        <OrangeBullet title="2. Service Overview">
          my HOOM enables users to purchase alcoholic beverages (e.g., beer) for
          other individuals ("Recipients") through participating, licensed
          vendors. We do not sell or deliver alcohol ourselves—we are a platform
          facilitating transactions between users and verified vendors.
        </OrangeBullet>

        <OrangeBullet title="3. Account Registration">
          To use the Service, you must create an account, provide accurate
          personal information, and consent to identity and age verification
          processes.
        </OrangeBullet>

        <OrangeBullet title="4. Age Verification">
          Recipients must be 21+ and will be required to verify their age and
          identity upon redemption of a gift. Failure to do so will result in
          cancellation without refund.
        </OrangeBullet>

        <Divider />

        <OrangeBullet title="5. Acceptable Use">You agree not to:</OrangeBullet>

        <div style={{ marginLeft: "20px", marginBottom: "20px" }}>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Violate any local, state, or federal law regarding alcohol use or
            transfer
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Impersonate others or use fraudulent payment methods
          </p>
          <p style={{ fontSize: "1rem", lineHeight: "1.8", color: "#444" }}>
            ● Harass, exploit, or abuse other users or vendors
          </p>
        </div>

        <OrangeBullet title="6. Payments & Refunds">
          All purchases are final once accepted by a vendor. Refunds will not be
          provided unless required by law or in the event of vendor failure. We
          use third-party payment processors; you agree to their terms as well.
        </OrangeBullet>

        <OrangeBullet title="7. Third-Party Vendors">
          We are not responsible for the acts, omissions, or product quality of
          third-party vendors. All liability for the sale and service of alcohol
          lies with the licensed seller.
        </OrangeBullet>

        <Divider />

        <OrangeBullet title="8. SMS & Text Messaging Consent (Opt-In Required)">
          By providing your mobile phone number and explicitly opting in, you
          consent to receive text messages (SMS/MMS) from my HOOM.
        </OrangeBullet>

        <div style={{ marginLeft: "20px", marginBottom: "20px" }}>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Your consent to receive text messages is voluntary and is not a
            condition of purchasing or using the Service.
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Messaging consent is separate from acceptance of these Terms of
            Service and our Privacy Policy.
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● You will only receive text messages if you clearly affirm consent,
            such as by selecting a checkbox or tapping a button stating: "I
            agree to receive text messages from my HOOM."
          </p>
        </div>

        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#444",
            marginBottom: "10px",
            marginLeft: "20px",
          }}
        >
          Types of messages may include, but are not limited to:
        </p>

        <div style={{ marginLeft: "20px", marginBottom: "20px" }}>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Account notifications and security alerts
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Order confirmations and transaction updates
          </p>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.8",
              color: "#444",
              marginBottom: "10px",
            }}
          >
            ● Customer support communications
          </p>
          <p style={{ fontSize: "1rem", lineHeight: "1.8", color: "#444" }}>
            ● Promotional or marketing messages (if separately opted into)
          </p>
        </div>

        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#444",
            marginBottom: "10px",
            marginLeft: "20px",
          }}
        >
          Message frequency may vary. Standard message and data rates may apply
          depending on your carrier.
        </p>

        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#444",
            marginBottom: "20px",
            marginLeft: "20px",
          }}
        >
          You may opt out of receiving text messages at any time by following
          the instructions provided in the message (e.g., replying STOP). For
          help, reply HELP or contact us at contact@myhoom.com.
        </p>

        <Divider />

        <OrangeBullet title="9. Limitation of Liability">
          To the fullest extent permitted by law, my HOOM is not liable for any
          direct, indirect, incidental, or consequential damages arising out of
          your use of the Service or any transaction.
        </OrangeBullet>

        <OrangeBullet title="10. Termination">
          We reserve the right to suspend or terminate accounts for violation of
          these Terms or applicable laws, with or without notice.
        </OrangeBullet>

        <OrangeBullet title="11. Modifications">
          We may update these Terms at any time. Continued use of the Service
          after changes indicates your acceptance of the revised Terms.
        </OrangeBullet>

        <OrangeBullet title="12. Governing Law">
          These Terms are governed by the laws of the state of Idaho,
          without regard to conflict-of-law principles.
        </OrangeBullet>

        <Divider />

        <OrangeBullet title="13. Contact Us">
          For questions or concerns, contact us at: contact@myhoom.com
        </OrangeBullet>

        <p style={{ marginTop: "40px", fontSize: "0.95rem", color: "#888" }}>
          Last updated: July 8, 2026
        </p>
      </main>
    </div>
  );
}

const topHeaderButtonStyle = {
  border: "none",
  borderRadius: "30px",
  width: "170px",
  height: "46px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "14px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

export default TermsOfUsePage;
